import {
    DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS,
    DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_FAILED,
    LOADING_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN,
    RESET_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN,
    NETWORK_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetDeleteAccountTypeMapping = () => {
    return { type: RESET_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN };
};

const deleteAccountTypeMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN });
    await adminServices
        .post("deleteacctMappingtAdmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN,
                payload: err
            });
        });
};

export { resetDeleteAccountTypeMapping, deleteAccountTypeMapping };
